import ApplicationSerializer from './application';

export default class DraftDocumentUploadLinkSerializer extends ApplicationSerializer {
  // `uploadLink` is response-only: it comes back from the create but is never sent.
  // Without this, Ember Data's string transform serializes the unset attribute as
  // `upload-link: null` on create, polluting the request body (and breaking the
  // create-contract: only `content-type` / `byte-size` are valid create attributes).
  attrs = {
    uploadLink: {
      serialize: false,
    },
  };
}
